<!-- 群组管理 -->
<template>
  <div style="background: #fff; padding: 15px">
    <el-form label-width="100px" :inline="true">
      <el-form-item label="群组名称：">
        <el-input
          v-model="searchName"
          placeholder="-请输入-"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="所属组织">
        <el-select v-model="orgId">
          <el-option
            :label="post.name"
            :value="post.id"
            v-for="post in orgList"
            :key="post.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList" :disabled="loading"
          >查询</el-button
        >
        <el-button type="info" @click="resetSearch" :disabled="loading"
          >重置</el-button
        >
      </el-form-item>
      <el-form-item>
        <div style="text-align: right; margin-bottom: 20px">
          <el-button type="primary" @click="addNewGroup" icon="el-icon-plus"
            >新增</el-button
          >
          <el-button
            type="primary"
            @click="updateGroup"
            icon="el-icon-edit-outline"
            >修改</el-button
          >
          <el-button type="primary" @click="viewGroup" icon="el-icon-view"
            >详情</el-button
          >
          <el-button type="primary" @click="deleteGroup" icon="el-icon-delete"
            >删除</el-button
          >
        </div>
      </el-form-item>
    </el-form>

    <div class="table_c">
      <el-table
        ref="table"
        class="ownerTable"
        :data="groupList"
        @selection-change="handleSelectionChange"
        @row-click="rowClicked"
        @cell-dblclick="gotoDetail"
        border
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column
          v-for="item in formTitles"
          :key="item.class"
          :prop="item.class"
          :label="item.labelName"
        ></el-table-column>
      </el-table>
    </div>

    <div
      style="display: flex; justify-content: space-between; margin-top: 15px"
    >
      <span style="color: #666666; font-size: 14px; line-height: 32px"
        >显示{{
          totalCount > 0
            ? (currentPage - 1) * pageSize +
              1 +
              "-" +
              (currentPage * pageSize > totalCount
                ? totalCount
                : currentPage * pageSize)
            : "0"
        }}，共{{ totalCount }}条记录</span
      >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>

    <el-dialog
      :title="isAddGroup ? '新增群组信息' : '修改群组信息'"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="addForm"
        :rules="isAddGroup ? addRules : editRules"
        ref="addForm"
        label-position="left"
        label-width="120px"
        class="my-form"
      >
        <el-form-item label="群组名称" prop="addGroupName">
          <el-input
            v-model="addForm.addGroupName"
            placeholder="-请输入-"
            clearable
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="所属组织" prop="orgId">
          <el-select
            v-model="addForm.orgId"
            placeholder="-请选择-"
            clearable
            :disabled="!isAddGroup"
          >
            <el-option
              v-for="option in orgList"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否默认" prop="defOption">
          <el-select
            v-model="addForm.isDefault"
            placeholder="-请选择-"
            clearable
          >
            <el-option
              v-for="option in defList"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="群组备注" prop="remark">
          <el-input
            type="textarea"
            :rows="5"
            v-model="addForm.remark"
            placeholder="-请输入-"
            clearable
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSaveAction">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getGroupService,
  addGroupService,
  modifyGroupService,
  deleteGroupService,
} from "../../services/groupService";
import {
  getOrgIdService, //根据用户id获取组织id
  getDeptService,
  getProjectGMListService,
  getGovService,
} from "@/services/sysSettingService";
import Constants from "@/utils/consts.js";
export default {
  name: "GroupList",
  data() {
    return {
      loading: false,
      groupList: [],
      currentPage: 1,
      pageSize: 10,
      searchName: "",
      orgId:'',
      totalCount: 0,
      selectItems: [],
      formTitles: [
        { class: "name", labelName: "群组名称" },
        { class: "orgName", labelName: "组织名称" },
        { class: "remark", labelName: "备注" },
      ],
      addRules: {
        addGroupName: [
          { required: true, message: "该项为必填项" },
          {
            min: 1,
            max: 50,
            message: "输入内容长度必须介于1到50之间",
            trigger: "blur",
          },
        ],
        remark: [
          {
            min: 1,
            max: 100,
            message: "输入内容长度必须介于1到100之间",
            trigger: "blur",
          },
        ],
        orgId: [{ required: true, message: "该项为必选项" }],
      },
      editRules: {
        addGroupName: [
          { required: true, message: "该项为必填项" },
          {
            min: 1,
            max: 50,
            message: "输入内容长度必须介于1到50之间",
            trigger: "blur",
          },
        ],
        remark: [
          {
            min: 1,
            max: 100,
            message: "输入内容长度必须介于1到100之间",
            trigger: "blur",
          },
        ],
      },
      addForm: {
        addGroupName: "",
        remark: "",
        id: null,
        orgId: null,
        isDefault: 0,
      },
      dialogVisible: false,
      isAddGroup: false,
      orgList: [],
      defList: [
        { id: 0, name: "否" },
        { id: 1, name: "是" },
      ],
    };
  }, //
  methods: {
    // 获取组织列表
    // 新建群组时要先选定组织，才能后续添加人员。群组是属于某个组织下的，不能跨组织建群组
    getOrgList() {
      getGovService({ pageIndex: -1 })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.orgList = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$message.error(Constants.Err_Msg);
        });
    },
    onActive(menuCode) {
      this.currentPage = 1;
      this.getList();
      this.getOrgList();
    },

    viewGroup() {
      if (this.selectItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.bus.$emit("navMenuChange", {
        routeId: "groupDetail",
        routeParam: {
          id: this.selectItems[0].id,
          type: "view",
        },
      });
    },

    gotoDetail(row, column, cell, event) {
      this.bus.$emit("navMenuChange", {
        routeId: "groupDetail",
        routeParam: {
          id: row.id,
          type: "view",
        },
      });
    },

    refreshList() {
      this.currentPage = 1;
      this.getList();
    },
    resetSearch() {
      this.searchName = "";
      this.orgId="";
      this.currentPage = 1;
      this.getList();
    },
    // 获取群组列表
    getList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      let param = {
        pageSize: this.pageSize,
        pageIndex: this.currentPage,
        name: this.searchName,
        orgId:this.orgId
      };
      getGroupService(param)
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.groupList = res.data || [];
            this.totalCount = res.total;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //点击新建按钮
    addNewGroup() {
      this.isAddGroup = true;
      // 清空form数据
      this.addForm.addGroupName = "";
      this.addForm.remark = "";
      this.addForm.id = null;
      this.addForm.orgId = null;
      this.addForm.isDefault = 0;
      if (this.$refs.addForm) {
        this.$refs.addForm.resetFields();
      }
      this.dialogVisible = true;
    },
    //点击修改按钮
    updateGroup() {
      if (this.selectItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      this.bus.$emit("navMenuChange", {
        routeId: "groupDetail",
        routeParam: {
          id: this.selectItems[0].id,
          openFlag: false,
          type: "edit",
        },
      });
    }, //

    deleteGroup() {
      //点击删除按钮并确认删除
      if (this.selectItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      this.$confirm("确定要删除群组?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        let ids = [];
        for (let index = 0; index < this.selectItems.length; index++) {
          const element = this.selectItems[index];
          ids.push(element.id);
        }
        let groupIdSet = ids.join(",");
        deleteGroupService({
          groupIdSet: groupIdSet,
        })
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              this.$alert(Constants.Ok_Msg, "提示");
              this.refreshList();
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    }, //
    //添加弹窗确认按钮
    onSaveAction() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;

        if (this.isAddGroup) {
          this.requestAddGroup();
        } else {
          this.requestUpdateGroup();
        }
      });
    }, //
    //请求接口创建
    requestAddGroup() {
      let params = {
        name: this.addForm.addGroupName,
        remark: this.addForm.remark,
        orgId: this.addForm.orgId,
        isDefault: this.addForm.isDefault,
      };
      addGroupService(params)
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Ok_Msg, "提示");
            this.dialogVisible = false;
            this.refreshList();
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    }, //
    //请求接口修改
    requestUpdateGroup() {
      modifyGroupService({
        id: this.addForm.id,
        name: this.addForm.addGroupName,
        remark: this.addForm.remark,
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Ok_Msg, "提示", {
              confirmButtonText: "确定",
            });
            this.dialogVisible = false;
            this.refreshList();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    }, //
    //修改分页参数
    handleSizeChange(pageSize) {
      this.currentPage = 1; // 更新size之后只能从第1页开始看，不然当前页码可能是没有数据的
      this.pageSize = pageSize;
      this.getList();
    }, //
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    }, //
    //更改选择项
    handleSelectionChange(val) {
      this.selectItems = val;
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.table.toggleRowSelection(row);
    },
  },
};
</script>

<style lang="scss" scoped>
.table_c {
  height: 600px;
  overflow: auto;
}

.my-form {
  /deep/.el-select {
    width: 100%;
  }
}
</style>
